import { useState, useEffect } from 'react';

export const useRateLimit = (limitHours: number = 1) => {
  const [lastGenerated, setLastGenerated] = useState<number | null>(null);
  const [canGenerate, setCanGenerate] = useState(true);
  const [timeUntilNext, setTimeUntilNext] = useState<number>(0);

  useEffect(() => {
    const storedTime = localStorage.getItem('lastNewsGeneration');
    if (storedTime) {
      setLastGenerated(parseInt(storedTime));
    }
  }, []);

  useEffect(() => {
    const checkRateLimit = () => {
      if (!lastGenerated) {
        setCanGenerate(true);
        setTimeUntilNext(0);
        return;
      }

      const now = Date.now();
      const timeDiff = now - lastGenerated;
      const limitMs = limitHours * 60 * 60 * 1000; // Convert hours to milliseconds

      if (timeDiff >= limitMs) {
        setCanGenerate(true);
        setTimeUntilNext(0);
      } else {
        setCanGenerate(false);
        setTimeUntilNext(limitMs - timeDiff);
      }
    };

    checkRateLimit();
    const interval = setInterval(checkRateLimit, 1000); // Update every second

    return () => clearInterval(interval);
  }, [lastGenerated, limitHours]);

  const markGenerated = () => {
    const now = Date.now();
    setLastGenerated(now);
    localStorage.setItem('lastNewsGeneration', now.toString());
    setCanGenerate(false);
  };

  const getTimeUntilNextString = () => {
    if (timeUntilNext <= 0) return '';
    
    const minutes = Math.ceil(timeUntilNext / (1000 * 60));
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    
    if (hours > 0) {
      return `${hours}h ${remainingMinutes}m`;
    }
    return `${remainingMinutes}m`;
  };

  return {
    canGenerate,
    markGenerated,
    timeUntilNext: getTimeUntilNextString(),
  };
};